module.exports = __webpack_public_path__ + "static/media/list_img.ea7a21fe.svg";